import React from "react";
import { Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import { getAllProducts, deleteProductById } from "../api";

const AdminProducts = ({ history }) => {

    const [products, setProducts] = useState([]);

    const fetchAllProducts = async () => {
        try {
            const list = await getAllProducts();
            setProducts(list.data);
        } 
        catch (error) {
            console.error("ERROR fetching all products");
            throw error;
        }
    }



    useEffect(() => {
        fetchAllProducts();
    }, []);

    return (<div id="product-box" className="form-group w-100">
                <br />
                <Link to="/admin" className='button '>
                    GO BACK
                </Link>
                <br />
                <div className='admin-products-head'>
                    <div>
                        <h1>My Products</h1>
                    </div>
                    
                    {/* <div className="centered">
                        <img src="http://cdn.shopify.com/s/files/1/2478/5296/collections/Our_Products02_Vector.png?v=1615111024"
                            style={{width: 600, height: 100}}
                            alt="All Products"
                            className="" />
                    </div> */}
                </div>
                <br />
                <div id="product" className="container centered">
                    {products.map((product, index) => {
            
                        return (
                            
                            <div key={index} className="card w-75 p-3 border-dark m-3 bg-body rounded">
                                <div className="form-group list-group-item card-title centered ">
                                    <div className="card card-title border-dark p-3 rounded w-75 centered">
                                        <h1 className="admin-product-name"><b>{ product.name}</b></h1> 
                                    </div>
                                </div>
                                <div className="horizGroup">
                                    <div className="m-3 ">
                                        <img src= { product.img_url } alt="Product Cover" className='admin-product-image' />
                                    </div>
                                    <div className="w-75">
                                        <div className="form-group">
                                            <b className="">Description:</b> {product.description }
                                        </div>
                                        <div className="form-group list-group-item-text">
                                            <b className="">Price:</b> { product.price }
                                        </div>
                                        <div className="form-group list-group-item-text text-danger">
                                            <b className="">QTY On-Hand:</b> {product.inventory_qty }
                                        </div>
                                        <div className="horizGroup">
                                            <button 
                                                onClick={async (event) => {
                                                    
                                                try {
                                            
                                                    const response = await deleteProductById(product.id);
                                                    console.log(response);
                                                    // history.push("/admin/products")
                                                    fetchAllProducts();
                                            
                                                }
                                                catch (err) {
                                                    console.error("trouble deleting product", err)
                                                }
                                                }} 
                                    
                                                type="submit" className="button">Delete Product</button>
                                                <Link className="button" to={"/update/" + product.id}>UPDATE</Link>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                            </div>
                        )
                    })}
                </div>
            </div>)

}

export default AdminProducts;